import { createContext } from "../ContextSelector";
var TableContext = createContext();
export default TableContext;